const THREE = require('three');

// =============================================================================
// POSTPROCESSING
// =============================================================================

THREE.EffectComposer = function(renderer, renderTarget) {

  this.renderer = renderer;

  if (renderTarget === undefined) {
    var parameters = {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter,
      format: THREE.RGBAFormat,
      stencilBuffer: false
    };
    var size = renderer.getSize();
    renderTarget = new THREE.WebGLRenderTarget(size.width, size.height, parameters);
  }

  this.renderTarget1 = renderTarget;
  this.renderTarget2 = renderTarget.clone();

  this.writeBuffer = this.renderTarget1;
  this.readBuffer = this.renderTarget2;

  this.passes = [];

  if (THREE.CopyShader === undefined) {
    console.error("THREE.EffectComposer relies on THREE.CopyShader");
  }

  this.copyPass = new THREE.ShaderPass(THREE.CopyShader);
};

THREE.EffectComposer.prototype = {

  swapBuffers: function() {
    var tmp = this.readBuffer;
    this.readBuffer = this.writeBuffer;
    this.writeBuffer = tmp;
  },

  addPass: function(pass) {
    this.passes.push(pass);
  },

  insertPass: function(pass, index) {
    this.passes.splice(index, 0, pass);
  },

  render: function(delta) {
    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;

    var maskActive = false;

    var pass, i, il = this.passes.length;

    for (i = 0; i < il; i ++) {

      pass = this.passes[ i ];

      if (! pass.enabled) {
        continue;
      }

      pass.render(this.renderer, this.writeBuffer, this.readBuffer, delta, maskActive);

      if (pass.needsSwap) {

        if (maskActive) {

          var context = this.renderer.context;

          context.stencilFunc(context.NOTEQUAL, 1, 0xffffffff);

          this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, delta);

          context.stencilFunc(context.EQUAL, 1, 0xffffffff);

        }

        this.swapBuffers();

      }

      if (pass instanceof THREE.MaskPass) {

        maskActive = true;

      } else if (pass instanceof THREE.ClearMaskPass) {

        maskActive = false;

      }

    }

  },

  reset: function(renderTarget) {

    if (renderTarget === undefined) {

      var size = this.renderer.getSize();

      renderTarget = this.renderTarget1.clone();
      renderTarget.setSize(size.width, size.height);

    }

    this.renderTarget1.dispose();
    this.renderTarget2.dispose();
    this.renderTarget1 = renderTarget;
    this.renderTarget2 = renderTarget.clone();

    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;

  },

  setSize: function(width, height) {

    this.renderTarget1.setSize(width, height);
    this.renderTarget2.setSize(width, height);

  }
};

// =============================================================================

THREE.RenderPass = function(scene, camera, overrideMaterial, clearColor, clearAlpha) {
  this.scene = scene;
  this.camera = camera;

  this.overrideMaterial = overrideMaterial;

  this.clearColor = clearColor;
  this.clearAlpha = (clearAlpha !== undefined) ? clearAlpha : 1;

  this.oldClearColor = new THREE.Color();
  this.oldClearAlpha = 1;

  this.enabled = true;
  this.clear = true;
  this.needsSwap = false;
};

THREE.RenderPass.prototype = {
  render: function(renderer, writeBuffer, readBuffer, delta) {

    this.scene.overrideMaterial = this.overrideMaterial;

    if (this.clearColor) {
      this.oldClearColor.copy(renderer.getClearColor());
      this.oldClearAlpha = renderer.getClearAlpha();

      renderer.setClearColor(this.clearColor, this.clearAlpha);
    }

    renderer.render(this.scene, this.camera, readBuffer, this.clear);

    if (this.clearColor) {
      renderer.setClearColor(this.oldClearColor, this.oldClearAlpha);
    }

    this.scene.overrideMaterial = null;
  }
};

// =============================================================================

THREE.ShaderPass = function(shader, textureID) {
  this.textureID = (textureID !== undefined) ? textureID : "tDiffuse";

  if (shader instanceof THREE.ShaderMaterial) {
    this.uniforms = shader.uniforms;
    this.material = shader;
  } else if (shader) {
    this.uniforms = THREE.UniformsUtils.clone(shader.uniforms);
    this.material = new THREE.ShaderMaterial({
      defines: shader.defines || {},
      uniforms: this.uniforms,
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader
    });
  }

  this.renderToScreen = false;
  this.enabled = true;
  this.needsSwap = true;
  this.clear = false;

  this.camera = new THREE.OrthographicCamera(- 1, 1, 1, - 1, 0, 1);
  this.scene = new THREE.Scene();

  this.quad = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), null);
  this.scene.add(this.quad);
};

THREE.ShaderPass.prototype = {
  render: function(renderer, writeBuffer, readBuffer, delta) {
    if (this.uniforms[ this.textureID ]) {
      this.uniforms[ this.textureID ].value = readBuffer;
    }

    this.quad.material = this.material;

    if (this.renderToScreen) {
      renderer.render(this.scene, this.camera);
    } else {
      renderer.render(this.scene, this.camera, writeBuffer, this.clear);
    }
  }
};

// =============================================================================

THREE.MaskPass = function(scene, camera) {
  this.scene = scene;
  this.camera = camera;

  this.enabled = true;
  this.clear = true;
  this.needsSwap = false;

  this.inverse = false;
};

THREE.MaskPass.prototype = {
  render: function(renderer, writeBuffer, readBuffer, delta) {
    var context = renderer.context;

    // don't update color or depth
    context.colorMask(false, false, false, false);
    context.depthMask(false);

    // set up stencil
    var writeValue, clearValue;

    if (this.inverse) {
      writeValue = 0;
      clearValue = 1;
    } else {
      writeValue = 1;
      clearValue = 0;
    }

    context.enable(context.STENCIL_TEST);
    context.stencilOp(context.REPLACE, context.REPLACE, context.REPLACE);
    context.stencilFunc(context.ALWAYS, writeValue, 0xffffffff);
    context.clearStencil(clearValue);

    // draw into the stencil buffer
    renderer.render(this.scene, this.camera, readBuffer, this.clear);
    renderer.render(this.scene, this.camera, writeBuffer, this.clear);

    // re-enable update of color and depth
    context.colorMask(true, true, true, true);
    context.depthMask(true);

    // only render where stencil is set to 1
    context.stencilFunc(context.EQUAL, 1, 0xffffffff);  // draw if == 1
    context.stencilOp(context.KEEP, context.KEEP, context.KEEP);
  }
};

THREE.ClearMaskPass = function() {
  this.enabled = true;
};

THREE.ClearMaskPass.prototype = {
  render: function(renderer, writeBuffer, readBuffer, delta) {
    var context = renderer.context;
    context.disable(context.STENCIL_TEST);
  }
};

// =============================================================================
// SHADERS
// =============================================================================

THREE.CopyShader = {
  uniforms: {
    "tDiffuse": { type: "t", value: null },
    "opacity":  { type: "f", value: 1.0 }
  },

  vertexShader: [
    "varying vec2 vUv;",
    "void main() {",
      "vUv = uv;",
      "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
    "}"
  ].join( "\n" ),

  fragmentShader: [
    "uniform float opacity;",
    "uniform sampler2D tDiffuse;",
    "varying vec2 vUv;",
    "void main() {",
      "vec4 texel = texture2D( tDiffuse, vUv );",
      "gl_FragColor = opacity * texel;",
    "}"
  ].join( "\n" )
};

// =============================================================================

THREE.FilmShader = {

  uniforms: {
    "tDiffuse":   { type: "t", value: null },
    "time":       { type: "f", value: 0.0 },
    "nIntensity": { type: "f", value: 0.5 },
    "sIntensity": { type: "f", value: 0.05 },
    "sCount":     { type: "f", value: 4096 },
    "grayscale":  { type: "i", value: 1 }
  },

  vertexShader: [
    "varying vec2 vUv;",
    "void main() {",
      "vUv = uv;",
      "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
    "}"
  ].join( "\n" ),

  fragmentShader: [
    // control parameter
    "uniform float time;",
    "uniform bool grayscale;",
    // noise effect intensity value (0 = no effect, 1 = full effect)
    "uniform float nIntensity;",
    // scanlines effect intensity value (0 = no effect, 1 = full effect)
    "uniform float sIntensity;",
    // scanlines effect count value (0 = no effect, 4096 = full effect)
    "uniform float sCount;",
    "uniform sampler2D tDiffuse;",
    "varying vec2 vUv;",
    "void main() {",
      // sample the source
      "vec4 cTextureScreen = texture2D( tDiffuse, vUv );",
      // make some noise
      "float x = vUv.x * vUv.y * time *  1000.0;",
      "x = mod( x, 13.0 ) * mod( x, 123.0 );",
      "float dx = mod( x, 0.01 );",
      // add noise
      "vec3 cResult = cTextureScreen.rgb + cTextureScreen.rgb * clamp( 0.1 + dx * 100.0, 0.0, 1.0 );",
      // get us a sine and cosine
      "vec2 sc = vec2( sin( vUv.y * sCount ), cos( vUv.y * sCount ) );",
      // add scanlines
      "cResult += cTextureScreen.rgb * vec3( sc.x, sc.y, sc.x ) * sIntensity;",
      // interpolate between source and result by intensity
      "cResult = cTextureScreen.rgb + clamp( nIntensity, 0.0,1.0 ) * ( cResult - cTextureScreen.rgb );",
      // convert to grayscale if desired
      "if( grayscale ) {",
        "cResult = vec3( cResult.r * 0.3 + cResult.g * 0.59 + cResult.b * 0.11 );",
      "}",
      "gl_FragColor =  vec4( cResult, cTextureScreen.a );",

    "}"
  ].join( "\n" )
};

// =============================================================================

THREE.RGBShiftShader = {
  uniforms: {
    "tDiffuse": { type: "t", value: null },
    "amount":   { type: "f", value: 0.005 },
    "angle":    { type: "f", value: 0.0 }
  },

  vertexShader: [
    "varying vec2 vUv;",
    "void main() {",
      "vUv = uv;",
      "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
    "}"
  ].join( "\n" ),

  fragmentShader: [
    "uniform sampler2D tDiffuse;",
    "uniform float amount;",
    "uniform float angle;",
    "varying vec2 vUv;",
    "void main() {",
      "vec2 offset = amount * vec2( cos(angle), sin(angle));",
      "vec4 cr = texture2D(tDiffuse, vUv + offset);",
      "vec4 cga = texture2D(tDiffuse, vUv);",
      "vec4 cb = texture2D(tDiffuse, vUv - offset);",
      "gl_FragColor = vec4(cr.r, cga.g, cb.b, cga.a);",
    "}"
  ].join( "\n" )
};

// =============================================================================
// BAD TV SHADER
// =============================================================================

/**
 * Uses Ashima WebGl Noise: https://github.com/ashima/webgl-noise
 *
 * Uniforms:
 * time: steadily increasing float passed in
 * distortion: amount of thick distortion
 * distortion2: amount of fine grain distortion
 * speed: distortion vertical travel speed
 * rollSpeed: vertical roll speed
 */

THREE.BadTVShader = {
  uniforms: {
    "tDiffuse":   { type: "t", value: null },
    "time":     { type: "f", value: 0.0 },
    "distortion":   { type: "f", value: 3.0 },
    "distortion2":  { type: "f", value: 5.0 },
    "speed":       { type: "f", value: 0.2 },
    "rollSpeed":    { type: "f", value: 0.1 },
  },

  vertexShader: [
    "varying vec2 vUv;",
    "void main() {",
    "vUv = uv;",
    "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
    "}"

  ].join("\n"),

  fragmentShader: [

    "uniform sampler2D tDiffuse;",
    "uniform float time;",
    "uniform float distortion;",
    "uniform float distortion2;",
    "uniform float speed;",
    "uniform float rollSpeed;",
    "varying vec2 vUv;",

    // Start Ashima 2D Simplex Noise

    "vec3 mod289(vec3 x) {",
    "  return x - floor(x * (1.0 / 289.0)) * 289.0;",
    "}",

    "vec2 mod289(vec2 x) {",
    "  return x - floor(x * (1.0 / 289.0)) * 289.0;",
    "}",

    "vec3 permute(vec3 x) {",
    "  return mod289(((x*34.0)+1.0)*x);",
    "}",

    "float snoise(vec2 v)",
    "  {",
    "  const vec4 C = vec4(0.211324865405187,  // (3.0-sqrt(3.0))/6.0",
    "                      0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)",
    "                     -0.577350269189626,  // -1.0 + 2.0 * C.x",
    "                      0.024390243902439); // 1.0 / 41.0",
    "  vec2 i  = floor(v + dot(v, C.yy) );",
    "  vec2 x0 = v -   i + dot(i, C.xx);",

    "  vec2 i1;",
    "  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);",
    "  vec4 x12 = x0.xyxy + C.xxzz;",
    " x12.xy -= i1;",

    "  i = mod289(i); // Avoid truncation effects in permutation",
    "  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))",
    "    + i.x + vec3(0.0, i1.x, 1.0 ));",

    "  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);",
    "  m = m*m ;",
    "  m = m*m ;",

    "  vec3 x = 2.0 * fract(p * C.www) - 1.0;",
    "  vec3 h = abs(x) - 0.5;",
    "  vec3 ox = floor(x + 0.5);",
    "  vec3 a0 = x - ox;",

    "  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );",

    "  vec3 g;",
    "  g.x  = a0.x  * x0.x  + h.x  * x0.y;",
    "  g.yz = a0.yz * x12.xz + h.yz * x12.yw;",
    "  return 130.0 * dot(m, g);",
    "}",

    // End Ashima 2D Simplex Noise

    "void main() {",

      "vec2 p = vUv;",
      "float ty = time*speed;",
      "float yt = p.y - ty;",
      //smooth distortion
      "float offset = snoise(vec2(yt*3.0,0.0))*0.2;",
      // boost distortion
      "offset = offset*distortion * offset*distortion * offset;",
      //add fine grain distortion
      "offset += snoise(vec2(yt*50.0,0.0))*distortion2*0.001;",
      //combine distortion on X with roll on Y
      "gl_FragColor = texture2D(tDiffuse,  vec2(fract(p.x + offset),fract(p.y-time*rollSpeed) ));",

    "}"

  ].join("\n")
};

// =============================================================================
// STATIC SHADER
// =============================================================================

/**
 * Static effect. Additively blended digital noise.
 * amount - amount of noise to add (0 - 1)
 * size - size of noise grains (pixels)
 */

THREE.StaticShader = {

  uniforms: {

    "tDiffuse": { type: "t", value: null },
    "time":     { type: "f", value: 0.0 },
    "amount":   { type: "f", value: 0.5 },
    "size":     { type: "f", value: 4.0 }
  },

  vertexShader: [

  "varying vec2 vUv;",

  "void main() {",

    "vUv = uv;",
    "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

  "}"

  ].join("\n"),

  fragmentShader: [

  "uniform sampler2D tDiffuse;",
  "uniform float time;",
  "uniform float amount;",
  "uniform float size;",

  "varying vec2 vUv;",

  "float rand(vec2 co){",
    "return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);",
  "}",

  "void main() {",
    "vec2 p = vUv;",
    "vec4 color = texture2D(tDiffuse, p);",
    "float xs = floor(gl_FragCoord.x / size);",
    "float ys = floor(gl_FragCoord.y / size);",
    "vec4 snow = vec4(rand(vec2(xs * time,ys * time))*amount);",

    //"gl_FragColor = color + amount * ( snow - color );", //interpolate

    "gl_FragColor = color+ snow;", //additive

  "}"

  ].join("\n")
};


// WEBPACK FOOTER //
// ./foo-tv-shaders.js